import { TableBody as TableBodyBase } from '@react-stately/table';
import { TableBodyProps as TableBodyBaseProps } from '@react-types/table';
import React from 'react';

export type TableBodyProps<T> = TableBodyBaseProps<T>;

// Override TS for Body to support NextUI specific props.
const TableBody = TableBodyBase as <T>(props: TableBodyProps<T>) => React.JSX.Element;

export default TableBody;
